export function staticMapUrl({ lat, lng, w = 240, h = 160 }) {
    const key = import.meta.env.VITE_GOOGLE_MAPS_API_KEY;
    if (!key) return null;
    if (lat == null || lng == null) return null;
    if (!Number.isFinite(lat) || !Number.isFinite(lng)) return null;
    // Shift the map center ~35 logical px east at zoom 14 so the marker
    // lands left-of-center, clear of the bottom-right pump icon overlay.
    // Mercator pixel-per-degree is latitude-independent at fixed zoom.
    const centerLng = lng + 0.003;
    const params = new URLSearchParams({
        center: `${lat},${centerLng}`,
        zoom: "14",
        size: `${w}x${h}`,
        scale: "2",
        maptype: "roadmap",
        markers: `color:red|${lat},${lng}`,
        key,
        language: "fi",
        region: "FI",
    });
    return `https://maps.googleapis.com/maps/api/staticmap?${params}`;
}

// Text-address variant for the provider-side list, where lat/lng are
// intentionally never sent (customer-info masking — see TarjouspyyntoListCard).
// Renders ONLY the address string already shown on the card, so a masked
// "Sarkatie, 01720 Vantaa" maps the area without revealing the exact site.
export function addressMapUrl({ address, w = 240, h = 160, zoom = 13, marker = false }) {
    const key = import.meta.env.VITE_GOOGLE_MAPS_API_KEY;
    if (!key) return null;
    const center = typeof address === "string" ? address.trim() : "";
    if (!center) return null;
    const params = new URLSearchParams({
        center,
        zoom: String(zoom),
        size: `${w}x${h}`,
        scale: "2",
        maptype: "roadmap",
        key,
        language: "fi",
        region: "FI",
    });
    if (marker) params.set("markers", `color:red|${center}`);
    return `https://maps.googleapis.com/maps/api/staticmap?${params}`;
}
